var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:!_vm.end?_vm.waiting?'typedText':'typedText2':'typedText1',domProps:{"innerHTML":_vm._s(_vm.typedText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }